export default __webpack_public_path__ + "static/media/img_1.ff712590.JPG";